import React, { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";

// Import images for checkmarks (orange and white versions)
import checkorange from '../../../../icons/check_orange.svg'
import checkwhite from '../../../../icons/check_white.svg'
import constants from "../../../../utils/constants";

// Navigation component for sponsor-related routes
export default function NavSponsor({
  campaign,               // Campaign data passed as a prop
  artPack,
  isWalletConnected,      // Boolean indicating if the wallet is connected
  menuState,              // Object containing check statuses
  setMenuState
}) {
  // State to enable/disable menu links based on campaign availability
  const [disableMenu, setDisableMenu] = useState(false);

  // Updates `disableMenu` based on whether `campaign` data is available
useEffect(() => {
  const hasCampaign = !!campaign;
  const hasArtPack = !!artPack;

  setDisableMenu(!(hasCampaign && hasArtPack));
  
  if (!hasCampaign) {
    setMenuState(null);
  }
}, [campaign, artPack]);


  // Click handler to prevent navigation if `disableMenu` is true
  const handleClick = (e) => {
    if (disableMenu) e.preventDefault();
  };

  return (
    <>
      {/* Sponsor link - disabled if wallet is not connected */}
      <NavLink
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav${isWalletConnected ? "" : " disable_nav"}`}
        end
        to="/sponsor"
      >
        {/* Displays checkmark if `menuState?.sponsor_check` is greater than 0 */}
        {({ isActive }) => (
          <>
            Sponsor
            {menuState?.sponsor_check > 0 && (
              <img
                className="menu-check-box"
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}

      </NavLink>

      {/* Campaign link - disabled if wallet is not connected or artist sponsoring is unavailable */}
      <NavLink
        onClick={(e) => {
          if (!isWalletConnected) e.preventDefault();
        }}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${!isWalletConnected ? "disable_nav" : ""}`
        }
        end
        to={`${constants.SPONSOR_BASE_PATH}/campaign`}
      >

        {({ isActive }) => (
          <>
            Campaign
            {!disableMenu && (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            )}
          </>
        )}
      </NavLink>

      {/* Background Price link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/background-price`}
      >
        {/* Displays checkmark if `menuState?.background_price_check` is greater than 0 */}
        {({ isActive }) => (
          <>
            Background Price
            {menuState?.background_price_check > 0 ? (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>

      {/* Distro Preset link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/distro-preset`}
      >
        {/* Displays checkmark if `menuState?.distro_preset_check` is greater than 0 */}
        {({ isActive }) => (
          <>
            Distro Preset
            {menuState?.distro_preset_check > 0 ? (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>

      {/* Rarity link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/rarity-background`}
      >
        {/* Displays checkmark if `menuState?.rarity_check` is greater than 0 */}
        {({ isActive }) => (
          <>
            Rarity
            {menuState?.rarity_check > 0 ? (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>

      {/* Campaign Website link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/website`}
      >
        {/* Displays checkmark if `menuState?.check_website_updated` is true */}
        {({ isActive }) => (
          <>
            Website
            {menuState?.check_website_updated ? (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>

      {/* Distro Colors link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/distro-colors`}
      >
        {/* Displays checkmark if `menuState?.distro_color_check` is greater than 0 */}
        {({ isActive }) => (
          <>
            Distro Colors
            {menuState?.distro_color_check > 0 ? (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>

      {/* Main Page link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/mainpage`}
      >
        {/* Displays checkmark if `menuState?.check_main_page_updated` is true */}
        {({ isActive }) => (
          <>
            Main Page
            {menuState?.check_main_page_updated ? (
              <img
                className={`menu-check-box`}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>

      {/* About link - disabled based on `disableMenu` state */}
      <NavLink
        onClick={handleClick}
        className={`list-group-item list-group-item-action list-group-item-light padding-left-nav ${disableMenu ? "disable_nav" : ""
          }`}
        end
        to={`${constants.SPONSOR_BASE_PATH}/about`}
      >
        {/* Displays checkmark if `menuState?.check_about_updated` is true */}
        {({ isActive }) => (
          <>
            About
            {menuState?.check_about_updated ? (
              <img
                className={`menu-check-box `}
                src={isActive ? checkwhite : checkorange}
                alt="img"
              />
            ) : (
              ""
            )}
          </>
        )}
      </NavLink>
    </>
  );
}
